import { GET_ENTERPRISES_ERROR, GET_ENTERPRISES_START, GET_ENTERPRISES_SUCCESS } from '../../types';

export default function get_enterprises(state, action) {
  switch (action.type) {
    case GET_ENTERPRISES_START:
      return { ...state };
    case GET_ENTERPRISES_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case GET_ENTERPRISES_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}
